import React, { useEffect } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import LoadingView from '@medflex/components/stories/LoadingView';
import { useTranslation } from 'react-i18next';
import { showAlertToast } from '@medflex/components/stories/Toast';
import isAnySessionChatId from '@medflex/utils/isAnySessionChatId';
import useLocationSearchParams from '../../hooks/useLocationSearchParams';
import useContactConnector from '../hooks/useContactConnector';
import useSessionInternal1on1 from '../hooks/useSessionInternal1on1';

const PhysicianContactConnectorModule = () => {
  const { userId } = useParams();
  const { t } = useTranslation();
  const { isTeamMember } = useLocationSearchParams();

  if (!isAnySessionChatId(userId) && !isTeamMember) {
    const { isConnected, connectedContacts, error } = useContactConnector([userId]);

    useEffect(() => {
      if (error) {
        showAlertToast(
          t('physician:toasts.contact_connector.title'),
          t('physician:toasts.contact_connector.text'),
          { toastId: 'contactConnectFailed' },
        );
      }
    }, [error]);

    if (error) return <Redirect to="/address-book" />;
    if (!isConnected) {
      return (
        <div className="flex flex-1 justify-center items-center">
          <LoadingView
            title={t('global:loading_app.title')}
            message={t('global:loading_app.message')}
          />
        </div>
      );
    }
    return <Redirect to={`/chat/${connectedContacts[0].id}`} />;
  }
  if (isTeamMember) {
    const { sessionId } = useSessionInternal1on1(userId);

    if (!sessionId) return null;
    return <Redirect to={`/chat/${sessionId}`} />;
  }
  return <Redirect to={`/chat/${userId}`} />;
};

PhysicianContactConnectorModule.propTypes = {};

export default PhysicianContactConnectorModule;
